import { Box, styled } from "@mui/material";

export const WelcomeAndIntructionsPopUpRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  padding: "3rem",
  boxSizing: "border-box",
  backdropFilter: "blur(0.5rem)",
  width: "90dvw",
  height: "90dvh",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  margin: "auto",
  background: `rgba(${theme?.palette?.companyColors?.neutralRGB}, 0.8)`,
  borderRadius: theme?.borderRadius?.small,
  overflowY: "auto",
  overflowX: "hidden",
  [theme.breakpoints.up("md")]: {
    "@media (orientation: portrait)": {
      width: "80dvw",
      height: "50dvh",
    },
  },
  [theme.breakpoints.up("lg")]: {
    width: "80dvw",
    height: "55dvh",
    padding: "5rem",
  },
  [theme.breakpoints.up("xl")]: {
    width: "60dvw",
    height: "70dvh",
    padding: "5rem",
    borderRadius: theme?.borderRadius?.big,
  },
}));

export const WelcomeAndIntructionsPopUpItem = styled(Box)(({ theme }) => ({
  zIndex: 1,
  maxHeight: "fit-content",
  width: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  flexBasis: "100%",
  gap: "0.25rem",
  textAlign: "center",
  minWidth: "13vw",
  fontSize: "1.2rem",
  [theme.breakpoints.up("md")]: {
    gap: "2rem",
  },
}));
